package ui.home

sealed interface HomeEvent {
    data object Logout : HomeEvent

    data object CollectNotifications : HomeEvent

    data object CancelCollectNotifications : HomeEvent

    data object UnsubscribeFromNotifications : HomeEvent

    data object CollectQbAuth: HomeEvent

    data object UnsubscribeFromQbAuth: HomeEvent
}